import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';

const TextField = ({
  required,
  name,
  errors,
  id,
  disabled,
  defaultValue,
  translationKey,
  register,
  autoComplete,
  showLabel,
}) => {
  const { t } = useTranslation('forms');

  const label = t(`labels.${translationKey}`);
  const placeholder = t(`placeholders.${translationKey}`);
  const fieldId = `${id}.${name}`;

  let errorMessage = '';
  if (errors) {
    if (errors.message.key) {
      errorMessage = t(`validations.${errors.message.key}`);
    } else if (errors.type === 'required') {
      errorMessage = t(`validations.field_required`);
    }
  }

  return (
    <Form.Field required={required && !disabled} error={!!errors}>
      {showLabel && <label htmlFor={fieldId}>{label}</label>}
      <input
        id={fieldId}
        name={fieldId}
        type='text'
        placeholder={placeholder}
        defaultValue={defaultValue}
        disabled={disabled}
        required={required && !disabled}
        ref={register({ required })}
        autoComplete={autoComplete}
      />
      {errors && <p style={{ color: 'red' }}>{errorMessage}</p>}
    </Form.Field>
  );
};

TextField.propTypes = {
  name: PropTypes.string.isRequired,
  errors: PropTypes.object,
  id: PropTypes.string.isRequired,
  register: PropTypes.func.isRequired,
  translationKey: PropTypes.string.isRequired,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  defaultValue: PropTypes.string,
  autoComplete: PropTypes.string,
  showLabel: PropTypes.string,
};

TextField.defaultProps = {
  errors: null,
  defaultValue: '',
  autoComplete: null,
  required: false,
  disabled: false,
  showLabel: true,
};

export default TextField;
